import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addAiWrite2Store } from '../../../redux/aiWrite/aiWriteSlice';
import './AiMenu.scss';

export default function AiMenu(props) {
    const [textareaVal, setTextareaVal] = useState('');

    const condition = ` Make SVG but give me only svg elements in string without <svg></svg>. The svg canvas size must be 600 by 450 pixels!
Use only <circle>, <line>, <polygon> and <rect>!
Only colors #000000, #ffffff, #666666, #ff0000, #ffaa00, #ffff00, #00ff00, #0000ff and #333333.
All elements must have an id and class. For example:
<rect id="square-12345" class="square" data-layername="square-1"> if square
<rect id="rect-12345" class="rectangle" data-layername="rect-1"> if rectangle
<line id="line-12345" class="line" data-layername="line-1">
<polygon id="triangle-12345" class="triangle" data-layername="triangle-1" data-direction="top"> if pointing up
<polygon id="triangle-12345" class="triangle" data-layername="triangle-1" data-direction="right"> if pointing right
<polygon id="triangle-12345" class="triangle" data-layername="triangle-1" data-direction="bottom"> if pointing down
<polygon id="triangle-12345" class="triangle" data-layername="triangle-1" data-direction="left"> if directed to the left
<circle id="circle-12345" class="circle" data-layername="circle-1">
Example id="triangle-12345" means that the number can be any and not repeat.`;

    const dispatch = useDispatch();

    const hendlerCloseAiMenu = () => {
        props.aiMenuToggle();
    }

    const handleTextareaChenge = (e) => {
        setTextareaVal(e.target.value);
    }

    const handlerClearAiTextarea = () => {
        setTextareaVal('');
    }

    const handlerAiGenerate = async () => {
        if (textareaVal && textareaVal.length > 7) {
            const prompt = 'Create an SVG. ' + textareaVal + condition;
    
            try {
                const res = await fetch('/api/message', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ content: prompt }),
                });
    
                const data = await res.json();

                handlerClearAiTextarea();
                hendlerCloseAiMenu();

                dispatch(addAiWrite2Store(data));
            } catch (error) {
                console.error("ERROR API:", error);
            }
        }
    }

    return(
        <section className="ai-menu_section">
            <header className="ai-menu_header">
                <h3 className="ai-menu_header-title">AI Write</h3>
                <button className="ai-menu-header_close-btn" onClick={hendlerCloseAiMenu}></button>
            </header>
            <section>
                <textarea className="ai-menu_textarea" value={textareaVal} placeholder="Describe your reticle idea.." maxLength="200" onChange={handleTextareaChenge}></textarea>
                <div className="ai-menu_textarea-btns">
                    <button className="ai-menu_btn ai-menu_clear-btn" onClick={handlerClearAiTextarea}>Clear</button>
                    <button className="ai-menu_btn ai-menu_generate-btn" onClick={handlerAiGenerate}>Generate</button>
                </div>
            </section>
        </section>
    )
}